
// NATIVE 
import React, { useEffect } from 'react';


// INSTALLED 
import { Grid, Typography, Divider, Box, Tooltip, IconButton } from '@mui/material';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';


// CUSTOM 
import InputField from '../../../../../components/formFields/InputField';
import TextAreaField from '../../../../../components/formFields/TextAreaField';
import CheckboxField from '../../../../../components/formFields/checkBoxField';
import AutocompleteField from '../../../../../components/formFields/autocompleteField';
import { getAvailableUsersRatingsStore } from '../../../../../store/ratings';
import AutocompleteMultiples from '../../../../../components/formFields/AutocompleteMultiples';
import { UploadButtonField } from '../../../../../components/formFields/uploadButtonField';
import { uploadImgStore } from '../../../../../store/uploaders/thunks';
import { SurveyImage } from '../../../configuracion-encuestas/components/FormSurvey';
// import { SurveyImage } from '../../../../calificaciones/configuracion-encuestas/ConfiguracionEncuestas';


export const CreateDevice = (props:any) => {

    const dispatch: any = useDispatch();
    const { values, setFieldValue } = useFormikContext<any>();
    const { users_select_ratings_devices } = useSelector((state: any) => state.ratingsDevices);

    const { formField: {
        name,
        description,
        is_user_required,
        is_single_user,
        is_multi_user,
        users,
        all_users,
        logo_device,
        logo_quality
      }
    } = props;

    useEffect(() => {
        dispatch(getAvailableUsersRatingsStore());
    }, []);

    const handleImageUpload = async (event: any, fieldName: string, previewName: string) => {
        const file = event.target.files[0];
        if (!file) return;

        // Create a local preview
        const localUrl = URL.createObjectURL(file);
        const oldImgName = values[fieldName];
        setFieldValue(previewName, localUrl);
        setFieldValue(fieldName, null);

        const codeFile = `survey_q`;
        const response = await dispatch(uploadImgStore(codeFile, file, () => {}));

        if (response.ok) {
            const imgName = (response.data && typeof response.data === 'object') ? response.data.imgName : response.data;
            setFieldValue(fieldName, imgName);
        } else {
            // Restore if fails
            setFieldValue(previewName, '');
            setFieldValue(fieldName, oldImgName);
            URL.revokeObjectURL(localUrl);
        }
    };

    const handleUserRequiredChange = (e: any) => {
        if (!e.target.checked) {
            setFieldValue(is_single_user.name, false);
            setFieldValue(is_multi_user.name, false);
            setFieldValue(users.name, []);
            setFieldValue(all_users.name, false);
        }
    };

    const handleSingleUserChange = (e: any) => {
        if (e.target.checked) {
            setFieldValue(is_multi_user.name, false);
            setFieldValue(all_users.name, false);
            setFieldValue(users.name, []);
        } else {
            setFieldValue(users.name, []);
        }
    };

    const handleMultiUserChange = (e: any) => {
        if (e.target.checked) {
            setFieldValue(is_single_user.name, false);
            setFieldValue(users.name, []);
        } else {
            setFieldValue(users.name, []);
            setFieldValue(all_users.name, false);
        }
    };

  return (
    <div>
        
        <Grid container spacing={2}>
            <Grid size={{ xs:12 }} sx={{ padding: 1 }}>
                <InputField 
                    name={name.name}
                    label={name.label}
                    variant="outlined"
                    autoComplete="off"  
                    fullWidth
                /> 
            </Grid>

            <Grid size={{ xs:12 }} sx={{ padding: 1 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, color: 'primary.main' }}>
                    Configuración de Calificación
                </Typography>
                <Divider sx={{ mb: 2 }} /> 
                 
                <Grid container spacing={1}>
                    <Grid size={{ xs: 12 }}>
                        <CheckboxField
                            name={is_user_required.name}
                            label={is_user_required.label}
                            onChange={handleUserRequiredChange}
                        />
                    </Grid>

                    {values[is_user_required.name] && (
                        <>
                            <Grid size={{ xs: 12 }}>
                                <CheckboxField
                                    name={is_single_user.name}
                                    label={is_single_user.label}
                                    onChange={handleSingleUserChange}
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <CheckboxField
                                    name={is_multi_user.name}
                                    label={is_multi_user.label}
                                    onChange={handleMultiUserChange}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>

            {(values[is_single_user.name] || values[is_multi_user.name]) && (
                <Grid size={{ xs:12 }} sx={{ padding: 1 }}>
                    <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1, bgcolor: 'action.hover' }}>
                        <Typography variant="caption" sx={{ display: 'block', mb: 2, fontWeight: 600 }}>
                            {values[is_single_user.name] ? 'Asignación Individual' : 'Asignación Múltiple'}
                        </Typography>

                        {values[is_multi_user.name] && (
                            <Box sx={{ mb: 2 }}>
                                <CheckboxField
                                    name={all_users.name}
                                    label={all_users.label}
                                    onChange={(e: any) => {
                                        if (e.target.checked) setFieldValue(users.name, []);
                                    }}
                                />
                            </Box>
                        )}

                        {values[is_single_user.name] && (
                            <AutocompleteField
                                name={users.name}
                                label={users.label}
                                options={users_select_ratings_devices}
                                fullWidth
                            />
                        )}

                        {(values[is_multi_user.name] && !values[all_users.name]) && (
                            <AutocompleteMultiples
                                name={users.name}
                                label={users.label}
                                options={users_select_ratings_devices}
                                fullWidth
                            />
                        )}
                    </Box>
                </Grid>
            )}

            <Grid size={{ xs:12 }} sx={{ padding: 1 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, color: 'primary.main' }}>
                    Personalización (Logos)
                </Typography>
                <Divider sx={{ mb: 2 }} />
                
                <Grid container spacing={3}>
                    {/* LOGO DISPOSITIVO */}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 600 }}>
                            {logo_device.label}
                        </Typography>
                        {!values[logo_device.name] && !values.logo_device_preview ? (
                            <UploadButtonField
                                text="Subir Logo"
                                name="logo_device_file"
                                accept="image/*"
                                onChange={(e: any) => handleImageUpload(e, logo_device.name, 'logo_device_preview')}
                                style={{ textTransform: 'none', fontSize: '0.8rem' }}
                            />
                        ) : (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, p: 1, border: '1px dashed #ccc', borderRadius: 1 }}>
                                {values.logo_device_preview ? (
                                    <Box
                                        component="img"
                                        src={values.logo_device_preview}
                                        sx={{ width: '100%', height: 100, borderRadius: 1, objectFit: 'contain', bgcolor: '#f5f5f5', border: '1px solid #ddd' }}
                                    />
                                ) : (
                                    <SurveyImage imageName={values[logo_device.name]} />
                                )}
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Tooltip title="Cambiar">
                                        <Box>
                                            <UploadButtonField
                                                text=""
                                                icon={<EditIcon fontSize="small" />}
                                                name="logo_device_file"
                                                accept="image/*"
                                                onChange={(e: any) => handleImageUpload(e, logo_device.name, 'logo_device_preview')}
                                                style={{ minWidth: 0, padding: '4px', borderRadius: '50%' }}
                                            />
                                        </Box>
                                    </Tooltip>
                                    <IconButton 
                                        size="small" 
                                        color="error" 
                                        onClick={() => {
                                            if (values.logo_device_preview) URL.revokeObjectURL(values.logo_device_preview);
                                            setFieldValue(logo_device.name, null);
                                            setFieldValue('logo_device_preview', '');
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            </Box>
                        )}
                    </Grid>

                    {/* LOGO CALIDAD */}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 600 }}>
                            {logo_quality.label}
                        </Typography>
                        {!values[logo_quality.name] && !values.logo_quality_preview ? (
                            <UploadButtonField
                                text="Subir Logo Calidad"
                                name="logo_quality_file"
                                accept="image/*"
                                onChange={(e: any) => handleImageUpload(e, logo_quality.name, 'logo_quality_preview')}
                                style={{ textTransform: 'none', fontSize: '0.8rem' }}
                            />
                        ) : (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, p: 1, border: '1px dashed #ccc', borderRadius: 1 }}>
                                {values.logo_quality_preview ? (
                                    <Box
                                        component="img"
                                        src={values.logo_quality_preview}
                                        sx={{ width: '100%', height: 100, borderRadius: 1, objectFit: 'contain', bgcolor: '#f5f5f5', border: '1px solid #ddd' }}
                                    />
                                ) : (
                                    <SurveyImage imageName={values[logo_quality.name]} />
                                )}
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Tooltip title="Cambiar">
                                        <Box>
                                            <UploadButtonField
                                                text=""
                                                icon={<EditIcon fontSize="small" />}
                                                name="logo_quality_file"
                                                accept="image/*"
                                                onChange={(e: any) => handleImageUpload(e, logo_quality.name, 'logo_quality_preview')}
                                                style={{ minWidth: 0, padding: '4px', borderRadius: '50%' }}
                                            />
                                        </Box>
                                    </Tooltip>
                                    <IconButton 
                                        size="small" 
                                        color="error" 
                                        onClick={() => {
                                            if (values.logo_quality_preview) URL.revokeObjectURL(values.logo_quality_preview);
                                            setFieldValue(logo_quality.name, null);
                                            setFieldValue('logo_quality_preview', '');
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Grid>

            <Grid size={{ xs:12 }} sx={{ padding: 1 }}>
                <TextAreaField 
                    name={description.name}
                    label={description.label}
                    variant="outlined"
                    autoComplete="off"  
                    fullWidth
                    rows={3}
                />
            </Grid>
        </Grid>
    </div>
  )
}
